import { create } from 'zustand';
import { authApi } from './api';

export const useAuth = create((set) => ({
  user: null,
  isLoading: true,
  isAuthenticated: false,

  init: async () => {
    const token = localStorage.getItem('cs_token');
    if (!token) { set({ isLoading: false }); return; }
    try {
      const res = await authApi.me();
      set({ user: res.data, isAuthenticated: true, isLoading: false });
    } catch {
      localStorage.removeItem('cs_token');
      set({ user: null, isAuthenticated: false, isLoading: false });
    }
  },

  register: async (form) => {
    const res = await authApi.register(form);
    const { user, accessToken, refreshToken } = res.data || {};
    localStorage.setItem('cs_token', accessToken);
    if (refreshToken) localStorage.setItem('cs_refresh_token', refreshToken);
    set({ user, isAuthenticated: true });
    return user;
  },

  login: async (email, password) => {
    const res = await authApi.login({ email, password });
    const { user, accessToken, refreshToken } = res.data || {};
    localStorage.setItem('cs_token', accessToken);
    if (refreshToken) localStorage.setItem('cs_refresh_token', refreshToken);
    set({ user, isAuthenticated: true });
    return user;
  },

  // Consume tokens returned from reset-password (or any flow that mints
  // fresh credentials). Shape matches register/login — user + accessToken
  // + optional refreshToken.
  setSession: ({ user, accessToken, refreshToken }) => {
    if (accessToken) localStorage.setItem('cs_token', accessToken);
    if (refreshToken) localStorage.setItem('cs_refresh_token', refreshToken);
    set({ user, isAuthenticated: !!user });
    return user;
  },

  logout: () => {
    localStorage.removeItem('cs_token');
    localStorage.removeItem('cs_refresh_token');
    set({ user: null, isAuthenticated: false });
  },
}));
